<template>
<div class="chapter">
<div class="inner_page">
<div id="Epub4211-5.html" xml:lang="en-US">
<div class="Basic-Text-Frame">
<p class="PN-I" id="toc_marker-6"><span class="char-style-override-2">for</span></p>
<p class="CT-with-Date-below para-style-override-8"><span class="char-style-override-9">G</span><span class="char-style-override-10">ore Vidal</span></p>
<p class="Date-below-CT para-style-override-9"><span class="char-style-override-10">1925–2012</span></p>
<p class="BT-1st-Para para-style-override-1">Who helped kick me into shape.</p>
<p class="BT-1st-Para para-style-override-1">The planet has lost its </p>
<p class="BT-1st-Para para-style-override-1">most barbed critic. </p>
<p class="BT-1st-Para para-style-override-1">The job of world-class </p>
<p class="BT-1st-Para para-style-override-1">pain-in-the-arse is now vacant.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Epub42115.vue?608f4526